import { scrubCopy } from './telemetry-text';
import type { TelemetryProps } from './telemetry.types';

/** Lo que el servicio de diálogos deja ver de un diálogo abierto: su modo y su encabezado. */
export interface DialogLike {
    mode: 'confirm' | 'outcome' | 'prompt' | 'choice';
    title?: string;
    kind?: string;
    variant?: string;
    code?: string;
    options?: { value: string }[];
}

/** El evento de un diálogo que se abre: el encabezado limpio de datos y, en un desenlace, su tipo y su código. */
export function describeDialogOpen (dialog: DialogLike): { name: string, props: TelemetryProps } {
    const props: TelemetryProps = { mode: dialog.mode };
    if (dialog.kind) props.kind = dialog.kind;
    if (dialog.variant) props.variant = dialog.variant;
    if (dialog.code) props.code = scrubCopy(dialog.code, 60);
    return { name: scrubCopy(dialog.title) || dialog.mode, props };
}

/**
 * Lo que contestó el usuario, sin el contenido: de un `prompt` solo si lo envió o lo canceló —lo
 * escrito no sale—; de una elección, el valor de la opción, que lo pone la vista y no el usuario.
 */
export function describeDialogAnswer (dialog: DialogLike, value: unknown): string {
    switch (dialog.mode) {
        case 'prompt': return value == null ? 'cancel' : 'submit';
        case 'choice': return value == null ? 'cancel' : `option:${scrubCopy(String(value), 40)}`;
        default:       return value === true ? 'confirm' : 'cancel';
    }
}
